(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1442"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1442"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ewJru", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9374dc55a96e46b$export$2e2bcd8739ae039);
const baseUrl = document.currentScript?.getAttribute("data-base") ?? "/";
const searchJsonUrl = baseUrl + "search.json";
const pagefindUrl = baseUrl + "pagefind/pagefind.js";
function $a9374dc55a96e46b$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("search", ()=>({
            _notes$: null,
            _pagefind: null,
            open: false,
            term: "",
            results: null,
            selectedId: null,
            init () {
                this.$watch("term", async ()=>{
                    const results = await this.search();
                    if (results) {
                        this.results = results;
                        this.open = true;
                        this.selectedId = this.results[0]?.id ?? null;
                    }
                });
            },
            get selectedIdx () {
                return this.results.findIndex((r)=>r.id === this.selectedId);
            },
            selectPrevResult () {
                const newIdx = Math.max(0, this.selectedIdx - 1);
                this.selectedId = this.results[newIdx].id;
            },
            selectNextResult () {
                const newIdx = Math.min(this.results.length - 1, this.selectedIdx + 1);
                this.selectedId = this.results[newIdx].id;
            },
            onKeyDown (event) {
                switch(event.key){
                    case "Escape":
                        this.open = false;
                        break;
                    case "ArrowUp":
                        event.preventDefault();
                        this.results && this.selectPrevResult();
                        break;
                    case "ArrowDown":
                        event.preventDefault();
                        this.results && this.selectNextResult();
                        break;
                    case "Enter":
                        event.preventDefault();
                        const result = this.results?.[this.selectedIdx];
                        if (result) window.location.href = result.url;
                        break;
                }
            },
            async fetchNotes () {
                if (!this._notes) this._notes = new Promise(async (resolve)=>{
                    const result = await fetch(searchJsonUrl).then((r)=>r.json());
                    resolve(result.notes);
                });
                return this._notes;
            },
            async loadPagefind () {
                if (!this._pagefind) this._pagefind = new Promise(async (resolve)=>{
                    // Workaround, waiting for https://github.com/parcel-bundler/parcel/issues/8316
                    const pagefind = await eval(`import("${pagefindUrl}")`);
                    await pagefind.options({
                        excerptLength: 15
                    });
                    resolve(pagefind);
                });
                return this._pagefind;
            },
            async search () {
                const pagefind = await this.loadPagefind();
                const tagsQuery = this.term.match(/#(\S+)/g) ?? [];
                const tags = tagsQuery.map((tag)=>tag.substring(1));
                const termWithoutTags = this.term.replace(/#(\S+)/g, "").trim();
                const searchTerm = termWithoutTags || null;
                const filters = tags.length ? {
                    tags: tags
                } : undefined;
                const search = await pagefind.debouncedSearch(searchTerm, {
                    filters: filters
                });
                if (!search) return null;
                const results = await Promise.all(search.results.map((x)=>x.data()));
                return results.map((x)=>({
                        id: x.url,
                        url: x.url,
                        title: x.meta.title,
                        excerpt: x.excerpt
                    }));
            }
        }));
}

});

// packages/alpinejs/src/scheduler.js
var $79d7d6ab855f5657$var$flushPending = false;
var $79d7d6ab855f5657$var$flushing = false;
var $79d7d6ab855f5657$var$queue = [];
var $79d7d6ab855f5657$var$lastFlushedIndex = -1;
var $79d7d6ab855f5657$var$transactionActive = false;
function $79d7d6ab855f5657$var$scheduler(callback) {
    $79d7d6ab855f5657$var$queueJob(callback);
}
function $79d7d6ab855f5657$var$startTransaction() {
    $79d7d6ab855f5657$var$transactionActive = true;
}
function $79d7d6ab855f5657$var$commitTransaction() {
    $79d7d6ab855f5657$var$transactionActive = false;
    $79d7d6ab855f5657$var$queueFlush();
}
function $79d7d6ab855f5657$var$queueJob(job) {
    if (!$79d7d6ab855f5657$var$queue.includes(job)) $79d7d6ab855f5657$var$queue.push(job);
    $79d7d6ab855f5657$var$queueFlush();
}
function $79d7d6ab855f5657$var$dequeueJob(job) {
    let index = $79d7d6ab855f5657$var$queue.indexOf(job);
    if (index !== -1 && index > $79d7d6ab855f5657$var$lastFlushedIndex) $79d7d6ab855f5657$var$queue.splice(index, 1);
}
function $79d7d6ab855f5657$var$queueFlush() {
    if (!$79d7d6ab855f5657$var$flushing && !$79d7d6ab855f5657$var$flushPending) {
        if ($79d7d6ab855f5657$var$transactionActive) return;
        $79d7d6ab855f5657$var$flushPending = true;
        queueMicrotask($79d7d6ab855f5657$var$flushJobs);
    }
}
function $79d7d6ab855f5657$var$flushJobs() {
    $79d7d6ab855f5657$var$flushPending = false;
    $79d7d6ab855f5657$var$flushing = true;
    for(let i = 0; i < $79d7d6ab855f5657$var$queue.length; i++){
        $79d7d6ab855f5657$var$queue[i]();
        $79d7d6ab855f5657$var$lastFlushedIndex = i;
    }
    $79d7d6ab855f5657$var$queue.length = 0;
    $79d7d6ab855f5657$var$lastFlushedIndex = -1;
    $79d7d6ab855f5657$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $79d7d6ab855f5657$var$reactive;
var $79d7d6ab855f5657$var$effect;
var $79d7d6ab855f5657$var$release;
var $79d7d6ab855f5657$var$raw;
var $79d7d6ab855f5657$var$shouldSchedule = true;
function $79d7d6ab855f5657$var$disableEffectScheduling(callback) {
    $79d7d6ab855f5657$var$shouldSchedule = false;
    callback();
    $79d7d6ab855f5657$var$shouldSchedule = true;
}
function $79d7d6ab855f5657$var$setReactivityEngine(engine) {
    $79d7d6ab855f5657$var$reactive = engine.reactive;
    $79d7d6ab855f5657$var$release = engine.release;
    $79d7d6ab855f5657$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($79d7d6ab855f5657$var$shouldSchedule) $79d7d6ab855f5657$var$scheduler(task);
                else task();
            }
        });
    $79d7d6ab855f5657$var$raw = engine.raw;
}
function $79d7d6ab855f5657$var$overrideEffect(override) {
    $79d7d6ab855f5657$var$effect = override;
}
function $79d7d6ab855f5657$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $79d7d6ab855f5657$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $79d7d6ab855f5657$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $79d7d6ab855f5657$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $79d7d6ab855f5657$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        firstTime = false;
    });
    return ()=>$79d7d6ab855f5657$var$release(effectReference);
}
async function $79d7d6ab855f5657$var$transaction(callback) {
    $79d7d6ab855f5657$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $79d7d6ab855f5657$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $79d7d6ab855f5657$var$onAttributeAddeds = [];
var $79d7d6ab855f5657$var$onElRemoveds = [];
var $79d7d6ab855f5657$var$onElAddeds = [];
function $79d7d6ab855f5657$var$onElAdded(callback) {
    $79d7d6ab855f5657$var$onElAddeds.push(callback);
}
function $79d7d6ab855f5657$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $79d7d6ab855f5657$var$onElRemoveds.push(callback);
    }
}
function $79d7d6ab855f5657$var$onAttributesAdded(callback) {
    $79d7d6ab855f5657$var$onAttributeAddeds.push(callback);
}
function $79d7d6ab855f5657$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $79d7d6ab855f5657$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $79d7d6ab855f5657$var$cleanupElement(el) {
    el._x_effects?.forEach($79d7d6ab855f5657$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $79d7d6ab855f5657$var$observer = new MutationObserver($79d7d6ab855f5657$var$onMutate);
var $79d7d6ab855f5657$var$currentlyObserving = false;
function $79d7d6ab855f5657$var$startObservingMutations() {
    $79d7d6ab855f5657$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $79d7d6ab855f5657$var$currentlyObserving = true;
}
function $79d7d6ab855f5657$var$stopObservingMutations() {
    $79d7d6ab855f5657$var$flushObserver();
    $79d7d6ab855f5657$var$observer.disconnect();
    $79d7d6ab855f5657$var$currentlyObserving = false;
}
var $79d7d6ab855f5657$var$queuedMutations = [];
function $79d7d6ab855f5657$var$flushObserver() {
    let records = $79d7d6ab855f5657$var$observer.takeRecords();
    $79d7d6ab855f5657$var$queuedMutations.push(()=>records.length > 0 && $79d7d6ab855f5657$var$onMutate(records));
    let queueLengthWhenTriggered = $79d7d6ab855f5657$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($79d7d6ab855f5657$var$queuedMutations.length === queueLengthWhenTriggered) while($79d7d6ab855f5657$var$queuedMutations.length > 0)$79d7d6ab855f5657$var$queuedMutations.shift()();
    });
}
function $79d7d6ab855f5657$var$mutateDom(callback) {
    if (!$79d7d6ab855f5657$var$currentlyObserving) return callback();
    $79d7d6ab855f5657$var$stopObservingMutations();
    let result = callback();
    $79d7d6ab855f5657$var$startObservingMutations();
    return result;
}
var $79d7d6ab855f5657$var$isCollecting = false;
var $79d7d6ab855f5657$var$deferredMutations = [];
function $79d7d6ab855f5657$var$deferMutations() {
    $79d7d6ab855f5657$var$isCollecting = true;
}
function $79d7d6ab855f5657$var$flushAndStopDeferringMutations() {
    $79d7d6ab855f5657$var$isCollecting = false;
    $79d7d6ab855f5657$var$onMutate($79d7d6ab855f5657$var$deferredMutations);
    $79d7d6ab855f5657$var$deferredMutations = [];
}
function $79d7d6ab855f5657$var$onMutate(mutations) {
    if ($79d7d6ab855f5657$var$isCollecting) {
        $79d7d6ab855f5657$var$deferredMutations = $79d7d6ab855f5657$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $79d7d6ab855f5657$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $79d7d6ab855f5657$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $79d7d6ab855f5657$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $79d7d6ab855f5657$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $79d7d6ab855f5657$var$scope(node) {
    return $79d7d6ab855f5657$var$mergeProxies($79d7d6ab855f5657$var$closestDataStack(node));
}
function $79d7d6ab855f5657$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$79d7d6ab855f5657$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $79d7d6ab855f5657$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $79d7d6ab855f5657$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $79d7d6ab855f5657$var$closestDataStack(node.parentNode);
}
function $79d7d6ab855f5657$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $79d7d6ab855f5657$var$mergeProxyTrap);
}
var $79d7d6ab855f5657$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $79d7d6ab855f5657$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $79d7d6ab855f5657$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $79d7d6ab855f5657$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $79d7d6ab855f5657$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$79d7d6ab855f5657$var$get(data2, path), (value)=>$79d7d6ab855f5657$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $79d7d6ab855f5657$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $79d7d6ab855f5657$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $79d7d6ab855f5657$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $79d7d6ab855f5657$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $79d7d6ab855f5657$var$magics = {};
function $79d7d6ab855f5657$var$magic(name, callback) {
    $79d7d6ab855f5657$var$magics[name] = callback;
}
function $79d7d6ab855f5657$var$injectMagics(obj, el) {
    let memoizedUtilities = $79d7d6ab855f5657$var$getUtilities(el);
    Object.entries($79d7d6ab855f5657$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $79d7d6ab855f5657$var$getUtilities(el) {
    let [utilities, cleanup2] = $79d7d6ab855f5657$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $79d7d6ab855f5657$var$interceptor,
        ...utilities
    };
    $79d7d6ab855f5657$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $79d7d6ab855f5657$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $79d7d6ab855f5657$var$handleError(e, el, expression);
    }
}
function $79d7d6ab855f5657$var$handleError(...args) {
    return $79d7d6ab855f5657$var$errorHandler(...args);
}
var $79d7d6ab855f5657$var$errorHandler = $79d7d6ab855f5657$var$normalErrorHandler;
function $79d7d6ab855f5657$var$setErrorHandler(handler4) {
    $79d7d6ab855f5657$var$errorHandler = handler4;
}
function $79d7d6ab855f5657$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $79d7d6ab855f5657$var$shouldAutoEvaluateFunctions = true;
function $79d7d6ab855f5657$var$dontAutoEvaluateFunctions(callback) {
    let cache = $79d7d6ab855f5657$var$shouldAutoEvaluateFunctions;
    $79d7d6ab855f5657$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $79d7d6ab855f5657$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $79d7d6ab855f5657$var$evaluate(el, expression, extras = {}) {
    let result;
    $79d7d6ab855f5657$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $79d7d6ab855f5657$var$evaluateLater(...args) {
    return $79d7d6ab855f5657$var$theEvaluatorFunction(...args);
}
var $79d7d6ab855f5657$var$theEvaluatorFunction = $79d7d6ab855f5657$var$normalEvaluator;
function $79d7d6ab855f5657$var$setEvaluator(newEvaluator) {
    $79d7d6ab855f5657$var$theEvaluatorFunction = newEvaluator;
}
var $79d7d6ab855f5657$var$theRawEvaluatorFunction;
function $79d7d6ab855f5657$var$setRawEvaluator(newEvaluator) {
    $79d7d6ab855f5657$var$theRawEvaluatorFunction = newEvaluator;
}
function $79d7d6ab855f5657$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $79d7d6ab855f5657$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$79d7d6ab855f5657$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $79d7d6ab855f5657$var$generateEvaluatorFromFunction(dataStack, expression) : $79d7d6ab855f5657$var$generateEvaluatorFromString(dataStack, expression, el);
    return $79d7d6ab855f5657$var$tryCatch.bind(null, el, expression, evaluator);
}
function $79d7d6ab855f5657$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$79d7d6ab855f5657$var$shouldAutoEvaluateFunctions) {
            $79d7d6ab855f5657$var$runIfTypeOfFunction(receiver, func, $79d7d6ab855f5657$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($79d7d6ab855f5657$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $79d7d6ab855f5657$var$runIfTypeOfFunction(receiver, result);
    };
}
var $79d7d6ab855f5657$var$evaluatorMemo = {};
function $79d7d6ab855f5657$var$generateFunctionFromString(expression, el) {
    if ($79d7d6ab855f5657$var$evaluatorMemo[expression]) return $79d7d6ab855f5657$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $79d7d6ab855f5657$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $79d7d6ab855f5657$var$evaluatorMemo[expression] = func;
    return func;
}
function $79d7d6ab855f5657$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $79d7d6ab855f5657$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $79d7d6ab855f5657$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$79d7d6ab855f5657$var$handleError(error2, el, expression));
            if (func.finished) {
                $79d7d6ab855f5657$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $79d7d6ab855f5657$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$79d7d6ab855f5657$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $79d7d6ab855f5657$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($79d7d6ab855f5657$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$79d7d6ab855f5657$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$79d7d6ab855f5657$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $79d7d6ab855f5657$var$evaluateRaw(...args) {
    return $79d7d6ab855f5657$var$theRawEvaluatorFunction(...args);
}
function $79d7d6ab855f5657$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $79d7d6ab855f5657$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$79d7d6ab855f5657$var$closestDataStack(el)
    ];
    let scope2 = $79d7d6ab855f5657$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $79d7d6ab855f5657$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $79d7d6ab855f5657$var$prefixAsString = "x-";
function $79d7d6ab855f5657$var$prefix(subject = "") {
    return $79d7d6ab855f5657$var$prefixAsString + subject;
}
function $79d7d6ab855f5657$var$setPrefix(newPrefix) {
    $79d7d6ab855f5657$var$prefixAsString = newPrefix;
}
var $79d7d6ab855f5657$var$directiveHandlers = {};
function $79d7d6ab855f5657$var$directive(name, callback) {
    $79d7d6ab855f5657$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$79d7d6ab855f5657$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $79d7d6ab855f5657$var$directiveOrder.indexOf(directive2);
            $79d7d6ab855f5657$var$directiveOrder.splice(pos >= 0 ? pos : $79d7d6ab855f5657$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $79d7d6ab855f5657$var$directiveExists(name) {
    return Object.keys($79d7d6ab855f5657$var$directiveHandlers).includes(name);
}
function $79d7d6ab855f5657$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $79d7d6ab855f5657$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($79d7d6ab855f5657$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($79d7d6ab855f5657$var$outNonAlpineAttributes).map($79d7d6ab855f5657$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($79d7d6ab855f5657$var$byPriority);
    return directives2.map((directive2)=>{
        return $79d7d6ab855f5657$var$getDirectiveHandler(el, directive2);
    });
}
function $79d7d6ab855f5657$var$attributesOnly(attributes) {
    return Array.from(attributes).map($79d7d6ab855f5657$var$toTransformedAttributes()).filter((attr)=>!$79d7d6ab855f5657$var$outNonAlpineAttributes(attr));
}
var $79d7d6ab855f5657$var$isDeferringHandlers = false;
var $79d7d6ab855f5657$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $79d7d6ab855f5657$var$currentHandlerStackKey = Symbol();
function $79d7d6ab855f5657$var$deferHandlingDirectives(callback) {
    $79d7d6ab855f5657$var$isDeferringHandlers = true;
    let key = Symbol();
    $79d7d6ab855f5657$var$currentHandlerStackKey = key;
    $79d7d6ab855f5657$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($79d7d6ab855f5657$var$directiveHandlerStacks.get(key).length)$79d7d6ab855f5657$var$directiveHandlerStacks.get(key).shift()();
        $79d7d6ab855f5657$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $79d7d6ab855f5657$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $79d7d6ab855f5657$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $79d7d6ab855f5657$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $79d7d6ab855f5657$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $79d7d6ab855f5657$var$evaluateLater.bind($79d7d6ab855f5657$var$evaluateLater, el),
        evaluate: $79d7d6ab855f5657$var$evaluate.bind($79d7d6ab855f5657$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $79d7d6ab855f5657$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $79d7d6ab855f5657$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $79d7d6ab855f5657$var$getElementBoundUtilities(el);
    $79d7d6ab855f5657$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $79d7d6ab855f5657$var$isDeferringHandlers ? $79d7d6ab855f5657$var$directiveHandlerStacks.get($79d7d6ab855f5657$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $79d7d6ab855f5657$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $79d7d6ab855f5657$var$into = (i)=>i;
function $79d7d6ab855f5657$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $79d7d6ab855f5657$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $79d7d6ab855f5657$var$attributeTransformers = [];
function $79d7d6ab855f5657$var$mapAttributes(callback) {
    $79d7d6ab855f5657$var$attributeTransformers.push(callback);
}
function $79d7d6ab855f5657$var$outNonAlpineAttributes({ name: name }) {
    return $79d7d6ab855f5657$var$alpineAttributeRegex().test(name);
}
var $79d7d6ab855f5657$var$alpineAttributeRegex = ()=>new RegExp(`^${$79d7d6ab855f5657$var$prefixAsString}([^:^.]+)\\b`);
function $79d7d6ab855f5657$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($79d7d6ab855f5657$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $79d7d6ab855f5657$var$DEFAULT = "DEFAULT";
var $79d7d6ab855f5657$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $79d7d6ab855f5657$var$DEFAULT,
    "teleport"
];
function $79d7d6ab855f5657$var$byPriority(a, b) {
    let typeA = $79d7d6ab855f5657$var$directiveOrder.indexOf(a.type) === -1 ? $79d7d6ab855f5657$var$DEFAULT : a.type;
    let typeB = $79d7d6ab855f5657$var$directiveOrder.indexOf(b.type) === -1 ? $79d7d6ab855f5657$var$DEFAULT : b.type;
    return $79d7d6ab855f5657$var$directiveOrder.indexOf(typeA) - $79d7d6ab855f5657$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $79d7d6ab855f5657$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $79d7d6ab855f5657$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$79d7d6ab855f5657$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $79d7d6ab855f5657$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $79d7d6ab855f5657$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $79d7d6ab855f5657$var$started = false;
function $79d7d6ab855f5657$var$start() {
    if ($79d7d6ab855f5657$var$started) $79d7d6ab855f5657$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $79d7d6ab855f5657$var$started = true;
    if (!document.body) $79d7d6ab855f5657$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $79d7d6ab855f5657$var$dispatch(document, "alpine:init");
    $79d7d6ab855f5657$var$dispatch(document, "alpine:initializing");
    $79d7d6ab855f5657$var$startObservingMutations();
    $79d7d6ab855f5657$var$onElAdded((el)=>$79d7d6ab855f5657$var$initTree(el, $79d7d6ab855f5657$var$walk));
    $79d7d6ab855f5657$var$onElRemoved((el)=>$79d7d6ab855f5657$var$destroyTree(el));
    $79d7d6ab855f5657$var$onAttributesAdded((el, attrs)=>{
        $79d7d6ab855f5657$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$79d7d6ab855f5657$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($79d7d6ab855f5657$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $79d7d6ab855f5657$var$initTree(el);
    });
    $79d7d6ab855f5657$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $79d7d6ab855f5657$var$warnAboutMissingPlugins();
    });
}
var $79d7d6ab855f5657$var$rootSelectorCallbacks = [];
var $79d7d6ab855f5657$var$initSelectorCallbacks = [];
function $79d7d6ab855f5657$var$rootSelectors() {
    return $79d7d6ab855f5657$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $79d7d6ab855f5657$var$allSelectors() {
    return $79d7d6ab855f5657$var$rootSelectorCallbacks.concat($79d7d6ab855f5657$var$initSelectorCallbacks).map((fn)=>fn());
}
function $79d7d6ab855f5657$var$addRootSelector(selectorCallback) {
    $79d7d6ab855f5657$var$rootSelectorCallbacks.push(selectorCallback);
}
function $79d7d6ab855f5657$var$addInitSelector(selectorCallback) {
    $79d7d6ab855f5657$var$initSelectorCallbacks.push(selectorCallback);
}
function $79d7d6ab855f5657$var$closestRoot(el, includeInitSelectors = false) {
    return $79d7d6ab855f5657$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $79d7d6ab855f5657$var$allSelectors() : $79d7d6ab855f5657$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $79d7d6ab855f5657$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (el.parentNode instanceof ShadowRoot) return $79d7d6ab855f5657$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $79d7d6ab855f5657$var$findClosest(el.parentElement, callback);
}
function $79d7d6ab855f5657$var$isRoot(el) {
    return $79d7d6ab855f5657$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $79d7d6ab855f5657$var$initInterceptors2 = [];
function $79d7d6ab855f5657$var$interceptInit(callback) {
    $79d7d6ab855f5657$var$initInterceptors2.push(callback);
}
var $79d7d6ab855f5657$var$markerDispenser = 1;
function $79d7d6ab855f5657$var$initTree(el, walker = $79d7d6ab855f5657$var$walk, intercept = ()=>{}) {
    if ($79d7d6ab855f5657$var$findClosest(el, (i)=>i._x_ignore)) return;
    $79d7d6ab855f5657$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $79d7d6ab855f5657$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $79d7d6ab855f5657$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $79d7d6ab855f5657$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $79d7d6ab855f5657$var$destroyTree(root, walker = $79d7d6ab855f5657$var$walk) {
    walker(root, (el)=>{
        $79d7d6ab855f5657$var$cleanupElement(el);
        $79d7d6ab855f5657$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $79d7d6ab855f5657$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($79d7d6ab855f5657$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $79d7d6ab855f5657$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $79d7d6ab855f5657$var$tickStack = [];
var $79d7d6ab855f5657$var$isHolding = false;
function $79d7d6ab855f5657$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $79d7d6ab855f5657$var$isHolding || setTimeout(()=>{
            $79d7d6ab855f5657$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $79d7d6ab855f5657$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $79d7d6ab855f5657$var$releaseNextTicks() {
    $79d7d6ab855f5657$var$isHolding = false;
    while($79d7d6ab855f5657$var$tickStack.length)$79d7d6ab855f5657$var$tickStack.shift()();
}
function $79d7d6ab855f5657$var$holdNextTicks() {
    $79d7d6ab855f5657$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $79d7d6ab855f5657$var$setClasses(el, value) {
    if (Array.isArray(value)) return $79d7d6ab855f5657$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $79d7d6ab855f5657$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $79d7d6ab855f5657$var$setClasses(el, value());
    return $79d7d6ab855f5657$var$setClassesFromString(el, value);
}
function $79d7d6ab855f5657$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $79d7d6ab855f5657$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $79d7d6ab855f5657$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $79d7d6ab855f5657$var$setStylesFromObject(el, value);
    return $79d7d6ab855f5657$var$setStylesFromString(el, value);
}
function $79d7d6ab855f5657$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $79d7d6ab855f5657$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $79d7d6ab855f5657$var$setStyles(el, previousStyles);
    };
}
function $79d7d6ab855f5657$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $79d7d6ab855f5657$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $79d7d6ab855f5657$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$79d7d6ab855f5657$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $79d7d6ab855f5657$var$registerTransitionsFromHelper(el, modifiers, value);
    else $79d7d6ab855f5657$var$registerTransitionsFromClassString(el, expression, value);
});
function $79d7d6ab855f5657$var$registerTransitionsFromClassString(el, classString, stage) {
    $79d7d6ab855f5657$var$registerTransitionObject(el, $79d7d6ab855f5657$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $79d7d6ab855f5657$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $79d7d6ab855f5657$var$registerTransitionObject(el, $79d7d6ab855f5657$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $79d7d6ab855f5657$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $79d7d6ab855f5657$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $79d7d6ab855f5657$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $79d7d6ab855f5657$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $79d7d6ab855f5657$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $79d7d6ab855f5657$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $79d7d6ab855f5657$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $79d7d6ab855f5657$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $79d7d6ab855f5657$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $79d7d6ab855f5657$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $79d7d6ab855f5657$var$closestHide(parent);
}
function $79d7d6ab855f5657$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $79d7d6ab855f5657$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $79d7d6ab855f5657$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $79d7d6ab855f5657$var$once(()=>{
        $79d7d6ab855f5657$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $79d7d6ab855f5657$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $79d7d6ab855f5657$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $79d7d6ab855f5657$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $79d7d6ab855f5657$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $79d7d6ab855f5657$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $79d7d6ab855f5657$var$mutateDom(()=>{
                stages.end();
            });
            $79d7d6ab855f5657$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $79d7d6ab855f5657$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $79d7d6ab855f5657$var$isCloning = false;
function $79d7d6ab855f5657$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$79d7d6ab855f5657$var$isCloning ? fallback(...args) : callback(...args);
}
function $79d7d6ab855f5657$var$onlyDuringClone(callback) {
    return (...args)=>$79d7d6ab855f5657$var$isCloning && callback(...args);
}
var $79d7d6ab855f5657$var$interceptors = [];
function $79d7d6ab855f5657$var$interceptClone(callback) {
    $79d7d6ab855f5657$var$interceptors.push(callback);
}
function $79d7d6ab855f5657$var$cloneNode(from, to) {
    $79d7d6ab855f5657$var$interceptors.forEach((i)=>i(from, to));
    $79d7d6ab855f5657$var$isCloning = true;
    $79d7d6ab855f5657$var$dontRegisterReactiveSideEffects(()=>{
        $79d7d6ab855f5657$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $79d7d6ab855f5657$var$isCloning = false;
}
var $79d7d6ab855f5657$var$isCloningLegacy = false;
function $79d7d6ab855f5657$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $79d7d6ab855f5657$var$isCloning = true;
    $79d7d6ab855f5657$var$isCloningLegacy = true;
    $79d7d6ab855f5657$var$dontRegisterReactiveSideEffects(()=>{
        $79d7d6ab855f5657$var$cloneTree(newEl);
    });
    $79d7d6ab855f5657$var$isCloning = false;
    $79d7d6ab855f5657$var$isCloningLegacy = false;
}
function $79d7d6ab855f5657$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $79d7d6ab855f5657$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $79d7d6ab855f5657$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $79d7d6ab855f5657$var$initTree(el, shallowWalker);
}
function $79d7d6ab855f5657$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $79d7d6ab855f5657$var$effect;
    $79d7d6ab855f5657$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $79d7d6ab855f5657$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $79d7d6ab855f5657$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $79d7d6ab855f5657$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $79d7d6ab855f5657$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $79d7d6ab855f5657$var$camelCase(name) : name;
    switch(name){
        case "value":
            $79d7d6ab855f5657$var$bindInputValue(el, value);
            break;
        case "style":
            $79d7d6ab855f5657$var$bindStyles(el, value);
            break;
        case "class":
            $79d7d6ab855f5657$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $79d7d6ab855f5657$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $79d7d6ab855f5657$var$bindAttribute(el, name, value);
            break;
    }
}
function $79d7d6ab855f5657$var$bindInputValue(el, value) {
    if ($79d7d6ab855f5657$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $79d7d6ab855f5657$var$safeParseBoolean(el.value) === value;
            else el.checked = $79d7d6ab855f5657$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($79d7d6ab855f5657$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$79d7d6ab855f5657$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $79d7d6ab855f5657$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $79d7d6ab855f5657$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $79d7d6ab855f5657$var$setClasses(el, value);
}
function $79d7d6ab855f5657$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $79d7d6ab855f5657$var$setStyles(el, value);
}
function $79d7d6ab855f5657$var$bindAttributeAndProperty(el, name, value) {
    $79d7d6ab855f5657$var$bindAttribute(el, name, value);
    $79d7d6ab855f5657$var$setPropertyIfChanged(el, name, value);
}
function $79d7d6ab855f5657$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $79d7d6ab855f5657$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($79d7d6ab855f5657$var$isBooleanAttr(name)) value = name;
        $79d7d6ab855f5657$var$setIfChanged(el, name, value);
    }
}
function $79d7d6ab855f5657$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $79d7d6ab855f5657$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $79d7d6ab855f5657$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $79d7d6ab855f5657$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $79d7d6ab855f5657$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $79d7d6ab855f5657$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $79d7d6ab855f5657$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $79d7d6ab855f5657$var$isBooleanAttr(attrName) {
    return $79d7d6ab855f5657$var$booleanAttributes.has(attrName);
}
function $79d7d6ab855f5657$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $79d7d6ab855f5657$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $79d7d6ab855f5657$var$getAttributeBinding(el, name, fallback);
}
function $79d7d6ab855f5657$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $79d7d6ab855f5657$var$dontAutoEvaluateFunctions(()=>{
            return $79d7d6ab855f5657$var$evaluate(el, binding.expression);
        });
    }
    return $79d7d6ab855f5657$var$getAttributeBinding(el, name, fallback);
}
function $79d7d6ab855f5657$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($79d7d6ab855f5657$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $79d7d6ab855f5657$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $79d7d6ab855f5657$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $79d7d6ab855f5657$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $79d7d6ab855f5657$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $79d7d6ab855f5657$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $79d7d6ab855f5657$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($79d7d6ab855f5657$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($79d7d6ab855f5657$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($79d7d6ab855f5657$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $79d7d6ab855f5657$var$release(reference);
    };
}
function $79d7d6ab855f5657$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $79d7d6ab855f5657$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($79d7d6ab855f5657$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $79d7d6ab855f5657$var$stores = {};
var $79d7d6ab855f5657$var$isReactive = false;
function $79d7d6ab855f5657$var$store(name, value) {
    if (!$79d7d6ab855f5657$var$isReactive) {
        $79d7d6ab855f5657$var$stores = $79d7d6ab855f5657$var$reactive($79d7d6ab855f5657$var$stores);
        $79d7d6ab855f5657$var$isReactive = true;
    }
    if (value === void 0) return $79d7d6ab855f5657$var$stores[name];
    $79d7d6ab855f5657$var$stores[name] = value;
    $79d7d6ab855f5657$var$initInterceptors($79d7d6ab855f5657$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $79d7d6ab855f5657$var$stores[name].init();
}
function $79d7d6ab855f5657$var$getStores() {
    return $79d7d6ab855f5657$var$stores;
}
// packages/alpinejs/src/binds.js
var $79d7d6ab855f5657$var$binds = {};
function $79d7d6ab855f5657$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $79d7d6ab855f5657$var$applyBindingsObject(name, getBindings());
    else $79d7d6ab855f5657$var$binds[name] = getBindings;
    return ()=>{};
}
function $79d7d6ab855f5657$var$injectBindingProviders(obj) {
    Object.entries($79d7d6ab855f5657$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $79d7d6ab855f5657$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $79d7d6ab855f5657$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $79d7d6ab855f5657$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $79d7d6ab855f5657$var$datas = {};
function $79d7d6ab855f5657$var$data(name, callback) {
    $79d7d6ab855f5657$var$datas[name] = callback;
}
function $79d7d6ab855f5657$var$injectDataProviders(obj, context) {
    Object.entries($79d7d6ab855f5657$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $79d7d6ab855f5657$var$Alpine = {
    get reactive () {
        return $79d7d6ab855f5657$var$reactive;
    },
    get release () {
        return $79d7d6ab855f5657$var$release;
    },
    get effect () {
        return $79d7d6ab855f5657$var$effect;
    },
    get raw () {
        return $79d7d6ab855f5657$var$raw;
    },
    get transaction () {
        return $79d7d6ab855f5657$var$transaction;
    },
    version: "3.15.8",
    flushAndStopDeferringMutations: $79d7d6ab855f5657$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $79d7d6ab855f5657$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $79d7d6ab855f5657$var$disableEffectScheduling,
    startObservingMutations: $79d7d6ab855f5657$var$startObservingMutations,
    stopObservingMutations: $79d7d6ab855f5657$var$stopObservingMutations,
    setReactivityEngine: $79d7d6ab855f5657$var$setReactivityEngine,
    onAttributeRemoved: $79d7d6ab855f5657$var$onAttributeRemoved,
    onAttributesAdded: $79d7d6ab855f5657$var$onAttributesAdded,
    closestDataStack: $79d7d6ab855f5657$var$closestDataStack,
    skipDuringClone: $79d7d6ab855f5657$var$skipDuringClone,
    onlyDuringClone: $79d7d6ab855f5657$var$onlyDuringClone,
    addRootSelector: $79d7d6ab855f5657$var$addRootSelector,
    addInitSelector: $79d7d6ab855f5657$var$addInitSelector,
    setErrorHandler: $79d7d6ab855f5657$var$setErrorHandler,
    interceptClone: $79d7d6ab855f5657$var$interceptClone,
    addScopeToNode: $79d7d6ab855f5657$var$addScopeToNode,
    deferMutations: $79d7d6ab855f5657$var$deferMutations,
    mapAttributes: $79d7d6ab855f5657$var$mapAttributes,
    evaluateLater: $79d7d6ab855f5657$var$evaluateLater,
    interceptInit: $79d7d6ab855f5657$var$interceptInit,
    initInterceptors: $79d7d6ab855f5657$var$initInterceptors,
    injectMagics: $79d7d6ab855f5657$var$injectMagics,
    setEvaluator: $79d7d6ab855f5657$var$setEvaluator,
    setRawEvaluator: $79d7d6ab855f5657$var$setRawEvaluator,
    mergeProxies: $79d7d6ab855f5657$var$mergeProxies,
    extractProp: $79d7d6ab855f5657$var$extractProp,
    findClosest: $79d7d6ab855f5657$var$findClosest,
    onElRemoved: $79d7d6ab855f5657$var$onElRemoved,
    closestRoot: $79d7d6ab855f5657$var$closestRoot,
    destroyTree: $79d7d6ab855f5657$var$destroyTree,
    interceptor: $79d7d6ab855f5657$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $79d7d6ab855f5657$var$transition,
    setStyles: // INTERNAL
    $79d7d6ab855f5657$var$setStyles,
    mutateDom: // INTERNAL
    $79d7d6ab855f5657$var$mutateDom,
    directive: $79d7d6ab855f5657$var$directive,
    entangle: $79d7d6ab855f5657$var$entangle,
    throttle: $79d7d6ab855f5657$var$throttle,
    debounce: $79d7d6ab855f5657$var$debounce,
    evaluate: $79d7d6ab855f5657$var$evaluate,
    evaluateRaw: $79d7d6ab855f5657$var$evaluateRaw,
    initTree: $79d7d6ab855f5657$var$initTree,
    nextTick: $79d7d6ab855f5657$var$nextTick,
    prefixed: $79d7d6ab855f5657$var$prefix,
    prefix: $79d7d6ab855f5657$var$setPrefix,
    plugin: $79d7d6ab855f5657$var$plugin,
    magic: $79d7d6ab855f5657$var$magic,
    store: $79d7d6ab855f5657$var$store,
    start: $79d7d6ab855f5657$var$start,
    clone: $79d7d6ab855f5657$var$clone,
    cloneNode: // INTERNAL
    $79d7d6ab855f5657$var$cloneNode,
    // INTERNAL
    bound: $79d7d6ab855f5657$var$getBinding,
    $data: $79d7d6ab855f5657$var$scope,
    watch: $79d7d6ab855f5657$var$watch,
    walk: $79d7d6ab855f5657$var$walk,
    data: $79d7d6ab855f5657$var$data,
    bind: $79d7d6ab855f5657$var$bind2
};
var $79d7d6ab855f5657$var$alpine_default = $79d7d6ab855f5657$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $79d7d6ab855f5657$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $79d7d6ab855f5657$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $79d7d6ab855f5657$var$isBooleanAttr2 = /* @__PURE__ */ $79d7d6ab855f5657$var$makeMap($79d7d6ab855f5657$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $79d7d6ab855f5657$var$EMPTY_OBJ = Object.freeze({});
var $79d7d6ab855f5657$var$EMPTY_ARR = Object.freeze([]);
var $79d7d6ab855f5657$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $79d7d6ab855f5657$var$hasOwn = (val, key)=>$79d7d6ab855f5657$var$hasOwnProperty.call(val, key);
var $79d7d6ab855f5657$var$isArray = Array.isArray;
var $79d7d6ab855f5657$var$isMap = (val)=>$79d7d6ab855f5657$var$toTypeString(val) === "[object Map]";
var $79d7d6ab855f5657$var$isString = (val)=>typeof val === "string";
var $79d7d6ab855f5657$var$isSymbol = (val)=>typeof val === "symbol";
var $79d7d6ab855f5657$var$isObject = (val)=>val !== null && typeof val === "object";
var $79d7d6ab855f5657$var$objectToString = Object.prototype.toString;
var $79d7d6ab855f5657$var$toTypeString = (value)=>$79d7d6ab855f5657$var$objectToString.call(value);
var $79d7d6ab855f5657$var$toRawType = (value)=>{
    return $79d7d6ab855f5657$var$toTypeString(value).slice(8, -1);
};
var $79d7d6ab855f5657$var$isIntegerKey = (key)=>$79d7d6ab855f5657$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $79d7d6ab855f5657$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $79d7d6ab855f5657$var$camelizeRE = /-(\w)/g;
var $79d7d6ab855f5657$var$camelize = $79d7d6ab855f5657$var$cacheStringFunction((str)=>{
    return str.replace($79d7d6ab855f5657$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $79d7d6ab855f5657$var$hyphenateRE = /\B([A-Z])/g;
var $79d7d6ab855f5657$var$hyphenate = $79d7d6ab855f5657$var$cacheStringFunction((str)=>str.replace($79d7d6ab855f5657$var$hyphenateRE, "-$1").toLowerCase());
var $79d7d6ab855f5657$var$capitalize = $79d7d6ab855f5657$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $79d7d6ab855f5657$var$toHandlerKey = $79d7d6ab855f5657$var$cacheStringFunction((str)=>str ? `on${$79d7d6ab855f5657$var$capitalize(str)}` : ``);
var $79d7d6ab855f5657$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $79d7d6ab855f5657$var$targetMap = /* @__PURE__ */ new WeakMap();
var $79d7d6ab855f5657$var$effectStack = [];
var $79d7d6ab855f5657$var$activeEffect;
var $79d7d6ab855f5657$var$ITERATE_KEY = Symbol("iterate");
var $79d7d6ab855f5657$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $79d7d6ab855f5657$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $79d7d6ab855f5657$var$effect2(fn, options = $79d7d6ab855f5657$var$EMPTY_OBJ) {
    if ($79d7d6ab855f5657$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $79d7d6ab855f5657$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $79d7d6ab855f5657$var$stop(effect3) {
    if (effect3.active) {
        $79d7d6ab855f5657$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $79d7d6ab855f5657$var$uid = 0;
function $79d7d6ab855f5657$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$79d7d6ab855f5657$var$effectStack.includes(effect3)) {
            $79d7d6ab855f5657$var$cleanup(effect3);
            try {
                $79d7d6ab855f5657$var$enableTracking();
                $79d7d6ab855f5657$var$effectStack.push(effect3);
                $79d7d6ab855f5657$var$activeEffect = effect3;
                return fn();
            } finally{
                $79d7d6ab855f5657$var$effectStack.pop();
                $79d7d6ab855f5657$var$resetTracking();
                $79d7d6ab855f5657$var$activeEffect = $79d7d6ab855f5657$var$effectStack[$79d7d6ab855f5657$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $79d7d6ab855f5657$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $79d7d6ab855f5657$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $79d7d6ab855f5657$var$shouldTrack = true;
var $79d7d6ab855f5657$var$trackStack = [];
function $79d7d6ab855f5657$var$pauseTracking() {
    $79d7d6ab855f5657$var$trackStack.push($79d7d6ab855f5657$var$shouldTrack);
    $79d7d6ab855f5657$var$shouldTrack = false;
}
function $79d7d6ab855f5657$var$enableTracking() {
    $79d7d6ab855f5657$var$trackStack.push($79d7d6ab855f5657$var$shouldTrack);
    $79d7d6ab855f5657$var$shouldTrack = true;
}
function $79d7d6ab855f5657$var$resetTracking() {
    const last = $79d7d6ab855f5657$var$trackStack.pop();
    $79d7d6ab855f5657$var$shouldTrack = last === void 0 ? true : last;
}
function $79d7d6ab855f5657$var$track(target, type, key) {
    if (!$79d7d6ab855f5657$var$shouldTrack || $79d7d6ab855f5657$var$activeEffect === void 0) return;
    let depsMap = $79d7d6ab855f5657$var$targetMap.get(target);
    if (!depsMap) $79d7d6ab855f5657$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($79d7d6ab855f5657$var$activeEffect)) {
        dep.add($79d7d6ab855f5657$var$activeEffect);
        $79d7d6ab855f5657$var$activeEffect.deps.push(dep);
        if ($79d7d6ab855f5657$var$activeEffect.options.onTrack) $79d7d6ab855f5657$var$activeEffect.options.onTrack({
            effect: $79d7d6ab855f5657$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $79d7d6ab855f5657$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $79d7d6ab855f5657$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $79d7d6ab855f5657$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $79d7d6ab855f5657$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$79d7d6ab855f5657$var$isArray(target)) {
                    add2(depsMap.get($79d7d6ab855f5657$var$ITERATE_KEY));
                    if ($79d7d6ab855f5657$var$isMap(target)) add2(depsMap.get($79d7d6ab855f5657$var$MAP_KEY_ITERATE_KEY));
                } else if ($79d7d6ab855f5657$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$79d7d6ab855f5657$var$isArray(target)) {
                    add2(depsMap.get($79d7d6ab855f5657$var$ITERATE_KEY));
                    if ($79d7d6ab855f5657$var$isMap(target)) add2(depsMap.get($79d7d6ab855f5657$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($79d7d6ab855f5657$var$isMap(target)) add2(depsMap.get($79d7d6ab855f5657$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $79d7d6ab855f5657$var$isNonTrackableKeys = /* @__PURE__ */ $79d7d6ab855f5657$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $79d7d6ab855f5657$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($79d7d6ab855f5657$var$isSymbol));
var $79d7d6ab855f5657$var$get2 = /* @__PURE__ */ $79d7d6ab855f5657$var$createGetter();
var $79d7d6ab855f5657$var$readonlyGet = /* @__PURE__ */ $79d7d6ab855f5657$var$createGetter(true);
var $79d7d6ab855f5657$var$arrayInstrumentations = /* @__PURE__ */ $79d7d6ab855f5657$var$createArrayInstrumentations();
function $79d7d6ab855f5657$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $79d7d6ab855f5657$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$79d7d6ab855f5657$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($79d7d6ab855f5657$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $79d7d6ab855f5657$var$pauseTracking();
            const res = $79d7d6ab855f5657$var$toRaw(this)[key].apply(this, args);
            $79d7d6ab855f5657$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $79d7d6ab855f5657$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $79d7d6ab855f5657$var$shallowReadonlyMap : $79d7d6ab855f5657$var$readonlyMap : shallow ? $79d7d6ab855f5657$var$shallowReactiveMap : $79d7d6ab855f5657$var$reactiveMap).get(target)) return target;
        const targetIsArray = $79d7d6ab855f5657$var$isArray(target);
        if (!isReadonly && targetIsArray && $79d7d6ab855f5657$var$hasOwn($79d7d6ab855f5657$var$arrayInstrumentations, key)) return Reflect.get($79d7d6ab855f5657$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($79d7d6ab855f5657$var$isSymbol(key) ? $79d7d6ab855f5657$var$builtInSymbols.has(key) : $79d7d6ab855f5657$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $79d7d6ab855f5657$var$track(target, "get", key);
        if (shallow) return res;
        if ($79d7d6ab855f5657$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$79d7d6ab855f5657$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($79d7d6ab855f5657$var$isObject(res)) return isReadonly ? $79d7d6ab855f5657$var$readonly(res) : $79d7d6ab855f5657$var$reactive2(res);
        return res;
    };
}
var $79d7d6ab855f5657$var$set2 = /* @__PURE__ */ $79d7d6ab855f5657$var$createSetter();
function $79d7d6ab855f5657$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $79d7d6ab855f5657$var$toRaw(value);
            oldValue = $79d7d6ab855f5657$var$toRaw(oldValue);
            if (!$79d7d6ab855f5657$var$isArray(target) && $79d7d6ab855f5657$var$isRef(oldValue) && !$79d7d6ab855f5657$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $79d7d6ab855f5657$var$isArray(target) && $79d7d6ab855f5657$var$isIntegerKey(key) ? Number(key) < target.length : $79d7d6ab855f5657$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $79d7d6ab855f5657$var$toRaw(receiver)) {
            if (!hadKey) $79d7d6ab855f5657$var$trigger(target, "add", key, value);
            else if ($79d7d6ab855f5657$var$hasChanged(value, oldValue)) $79d7d6ab855f5657$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $79d7d6ab855f5657$var$deleteProperty(target, key) {
    const hadKey = $79d7d6ab855f5657$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $79d7d6ab855f5657$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $79d7d6ab855f5657$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$79d7d6ab855f5657$var$isSymbol(key) || !$79d7d6ab855f5657$var$builtInSymbols.has(key)) $79d7d6ab855f5657$var$track(target, "has", key);
    return result;
}
function $79d7d6ab855f5657$var$ownKeys(target) {
    $79d7d6ab855f5657$var$track(target, "iterate", $79d7d6ab855f5657$var$isArray(target) ? "length" : $79d7d6ab855f5657$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $79d7d6ab855f5657$var$mutableHandlers = {
    get: $79d7d6ab855f5657$var$get2,
    set: $79d7d6ab855f5657$var$set2,
    deleteProperty: $79d7d6ab855f5657$var$deleteProperty,
    has: $79d7d6ab855f5657$var$has,
    ownKeys: $79d7d6ab855f5657$var$ownKeys
};
var $79d7d6ab855f5657$var$readonlyHandlers = {
    get: $79d7d6ab855f5657$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $79d7d6ab855f5657$var$toReactive = (value)=>$79d7d6ab855f5657$var$isObject(value) ? $79d7d6ab855f5657$var$reactive2(value) : value;
var $79d7d6ab855f5657$var$toReadonly = (value)=>$79d7d6ab855f5657$var$isObject(value) ? $79d7d6ab855f5657$var$readonly(value) : value;
var $79d7d6ab855f5657$var$toShallow = (value)=>value;
var $79d7d6ab855f5657$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $79d7d6ab855f5657$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $79d7d6ab855f5657$var$toRaw(target);
    const rawKey = $79d7d6ab855f5657$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $79d7d6ab855f5657$var$track(rawTarget, "get", key);
    !isReadonly && $79d7d6ab855f5657$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $79d7d6ab855f5657$var$getProto(rawTarget);
    const wrap = isShallow ? $79d7d6ab855f5657$var$toShallow : isReadonly ? $79d7d6ab855f5657$var$toReadonly : $79d7d6ab855f5657$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $79d7d6ab855f5657$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $79d7d6ab855f5657$var$toRaw(target);
    const rawKey = $79d7d6ab855f5657$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $79d7d6ab855f5657$var$track(rawTarget, "has", key);
    !isReadonly && $79d7d6ab855f5657$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $79d7d6ab855f5657$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $79d7d6ab855f5657$var$track($79d7d6ab855f5657$var$toRaw(target), "iterate", $79d7d6ab855f5657$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $79d7d6ab855f5657$var$add(value) {
    value = $79d7d6ab855f5657$var$toRaw(value);
    const target = $79d7d6ab855f5657$var$toRaw(this);
    const proto = $79d7d6ab855f5657$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $79d7d6ab855f5657$var$trigger(target, "add", value, value);
    }
    return this;
}
function $79d7d6ab855f5657$var$set$1(key, value) {
    value = $79d7d6ab855f5657$var$toRaw(value);
    const target = $79d7d6ab855f5657$var$toRaw(this);
    const { has: has2, get: get3 } = $79d7d6ab855f5657$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $79d7d6ab855f5657$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $79d7d6ab855f5657$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $79d7d6ab855f5657$var$trigger(target, "add", key, value);
    else if ($79d7d6ab855f5657$var$hasChanged(value, oldValue)) $79d7d6ab855f5657$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $79d7d6ab855f5657$var$deleteEntry(key) {
    const target = $79d7d6ab855f5657$var$toRaw(this);
    const { has: has2, get: get3 } = $79d7d6ab855f5657$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $79d7d6ab855f5657$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $79d7d6ab855f5657$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $79d7d6ab855f5657$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $79d7d6ab855f5657$var$clear() {
    const target = $79d7d6ab855f5657$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $79d7d6ab855f5657$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $79d7d6ab855f5657$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $79d7d6ab855f5657$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $79d7d6ab855f5657$var$toRaw(target);
        const wrap = isShallow ? $79d7d6ab855f5657$var$toShallow : isReadonly ? $79d7d6ab855f5657$var$toReadonly : $79d7d6ab855f5657$var$toReactive;
        !isReadonly && $79d7d6ab855f5657$var$track(rawTarget, "iterate", $79d7d6ab855f5657$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $79d7d6ab855f5657$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $79d7d6ab855f5657$var$toRaw(target);
        const targetIsMap = $79d7d6ab855f5657$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $79d7d6ab855f5657$var$toShallow : isReadonly ? $79d7d6ab855f5657$var$toReadonly : $79d7d6ab855f5657$var$toReactive;
        !isReadonly && $79d7d6ab855f5657$var$track(rawTarget, "iterate", isKeyOnly ? $79d7d6ab855f5657$var$MAP_KEY_ITERATE_KEY : $79d7d6ab855f5657$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $79d7d6ab855f5657$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$79d7d6ab855f5657$var$capitalize(type)} operation ${key}failed: target is readonly.`, $79d7d6ab855f5657$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $79d7d6ab855f5657$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $79d7d6ab855f5657$var$get$1(this, key);
        },
        get size () {
            return $79d7d6ab855f5657$var$size(this);
        },
        has: $79d7d6ab855f5657$var$has$1,
        add: $79d7d6ab855f5657$var$add,
        set: $79d7d6ab855f5657$var$set$1,
        delete: $79d7d6ab855f5657$var$deleteEntry,
        clear: $79d7d6ab855f5657$var$clear,
        forEach: $79d7d6ab855f5657$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $79d7d6ab855f5657$var$get$1(this, key, false, true);
        },
        get size () {
            return $79d7d6ab855f5657$var$size(this);
        },
        has: $79d7d6ab855f5657$var$has$1,
        add: $79d7d6ab855f5657$var$add,
        set: $79d7d6ab855f5657$var$set$1,
        delete: $79d7d6ab855f5657$var$deleteEntry,
        clear: $79d7d6ab855f5657$var$clear,
        forEach: $79d7d6ab855f5657$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $79d7d6ab855f5657$var$get$1(this, key, true);
        },
        get size () {
            return $79d7d6ab855f5657$var$size(this, true);
        },
        has (key) {
            return $79d7d6ab855f5657$var$has$1.call(this, key, true);
        },
        add: $79d7d6ab855f5657$var$createReadonlyMethod("add"),
        set: $79d7d6ab855f5657$var$createReadonlyMethod("set"),
        delete: $79d7d6ab855f5657$var$createReadonlyMethod("delete"),
        clear: $79d7d6ab855f5657$var$createReadonlyMethod("clear"),
        forEach: $79d7d6ab855f5657$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $79d7d6ab855f5657$var$get$1(this, key, true, true);
        },
        get size () {
            return $79d7d6ab855f5657$var$size(this, true);
        },
        has (key) {
            return $79d7d6ab855f5657$var$has$1.call(this, key, true);
        },
        add: $79d7d6ab855f5657$var$createReadonlyMethod("add"),
        set: $79d7d6ab855f5657$var$createReadonlyMethod("set"),
        delete: $79d7d6ab855f5657$var$createReadonlyMethod("delete"),
        clear: $79d7d6ab855f5657$var$createReadonlyMethod("clear"),
        forEach: $79d7d6ab855f5657$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $79d7d6ab855f5657$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $79d7d6ab855f5657$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $79d7d6ab855f5657$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $79d7d6ab855f5657$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$79d7d6ab855f5657$var$mutableInstrumentations, $79d7d6ab855f5657$var$readonlyInstrumentations, $79d7d6ab855f5657$var$shallowInstrumentations, $79d7d6ab855f5657$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $79d7d6ab855f5657$var$createInstrumentations();
function $79d7d6ab855f5657$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $79d7d6ab855f5657$var$shallowReadonlyInstrumentations : $79d7d6ab855f5657$var$shallowInstrumentations : isReadonly ? $79d7d6ab855f5657$var$readonlyInstrumentations : $79d7d6ab855f5657$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($79d7d6ab855f5657$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $79d7d6ab855f5657$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $79d7d6ab855f5657$var$createInstrumentationGetter(false, false)
};
var $79d7d6ab855f5657$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $79d7d6ab855f5657$var$createInstrumentationGetter(true, false)
};
function $79d7d6ab855f5657$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $79d7d6ab855f5657$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $79d7d6ab855f5657$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $79d7d6ab855f5657$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $79d7d6ab855f5657$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $79d7d6ab855f5657$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $79d7d6ab855f5657$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $79d7d6ab855f5657$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $79d7d6ab855f5657$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $79d7d6ab855f5657$var$targetTypeMap($79d7d6ab855f5657$var$toRawType(value));
}
function $79d7d6ab855f5657$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $79d7d6ab855f5657$var$createReactiveObject(target, false, $79d7d6ab855f5657$var$mutableHandlers, $79d7d6ab855f5657$var$mutableCollectionHandlers, $79d7d6ab855f5657$var$reactiveMap);
}
function $79d7d6ab855f5657$var$readonly(target) {
    return $79d7d6ab855f5657$var$createReactiveObject(target, true, $79d7d6ab855f5657$var$readonlyHandlers, $79d7d6ab855f5657$var$readonlyCollectionHandlers, $79d7d6ab855f5657$var$readonlyMap);
}
function $79d7d6ab855f5657$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$79d7d6ab855f5657$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $79d7d6ab855f5657$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $79d7d6ab855f5657$var$toRaw(observed) {
    return observed && $79d7d6ab855f5657$var$toRaw(observed["__v_raw"]) || observed;
}
function $79d7d6ab855f5657$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$79d7d6ab855f5657$var$magic("nextTick", ()=>$79d7d6ab855f5657$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$79d7d6ab855f5657$var$magic("dispatch", (el)=>$79d7d6ab855f5657$var$dispatch.bind($79d7d6ab855f5657$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$79d7d6ab855f5657$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $79d7d6ab855f5657$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$79d7d6ab855f5657$var$magic("store", $79d7d6ab855f5657$var$getStores);
// packages/alpinejs/src/magics/$data.js
$79d7d6ab855f5657$var$magic("data", (el)=>$79d7d6ab855f5657$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$79d7d6ab855f5657$var$magic("root", (el)=>$79d7d6ab855f5657$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$79d7d6ab855f5657$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $79d7d6ab855f5657$var$mergeProxies($79d7d6ab855f5657$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $79d7d6ab855f5657$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $79d7d6ab855f5657$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $79d7d6ab855f5657$var$globalIdMemo = {};
function $79d7d6ab855f5657$var$findAndIncrementId(name) {
    if (!$79d7d6ab855f5657$var$globalIdMemo[name]) $79d7d6ab855f5657$var$globalIdMemo[name] = 0;
    return ++$79d7d6ab855f5657$var$globalIdMemo[name];
}
function $79d7d6ab855f5657$var$closestIdRoot(el, name) {
    return $79d7d6ab855f5657$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $79d7d6ab855f5657$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $79d7d6ab855f5657$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$79d7d6ab855f5657$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $79d7d6ab855f5657$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $79d7d6ab855f5657$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $79d7d6ab855f5657$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$79d7d6ab855f5657$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $79d7d6ab855f5657$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$79d7d6ab855f5657$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$79d7d6ab855f5657$var$warnMissingPluginMagic("Focus", "focus", "focus");
$79d7d6ab855f5657$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $79d7d6ab855f5657$var$warnMissingPluginMagic(name, magicName, slug) {
    $79d7d6ab855f5657$var$magic(magicName, (el)=>$79d7d6ab855f5657$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$79d7d6ab855f5657$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $79d7d6ab855f5657$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$79d7d6ab855f5657$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $79d7d6ab855f5657$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $79d7d6ab855f5657$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $79d7d6ab855f5657$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $79d7d6ab855f5657$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $79d7d6ab855f5657$var$skipDuringClone(()=>{
            $79d7d6ab855f5657$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $79d7d6ab855f5657$var$getTarget(expression);
        $79d7d6ab855f5657$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$79d7d6ab855f5657$var$mutateDom(()=>{
            clone2.remove();
            $79d7d6ab855f5657$var$destroyTree(clone2);
        }));
});
var $79d7d6ab855f5657$var$teleportContainerDuringClone = document.createElement("div");
function $79d7d6ab855f5657$var$getTarget(expression) {
    let target = $79d7d6ab855f5657$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $79d7d6ab855f5657$var$teleportContainerDuringClone;
    })();
    if (!target) $79d7d6ab855f5657$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $79d7d6ab855f5657$var$handler = ()=>{};
$79d7d6ab855f5657$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$79d7d6ab855f5657$var$directive("ignore", $79d7d6ab855f5657$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$79d7d6ab855f5657$var$directive("effect", $79d7d6ab855f5657$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($79d7d6ab855f5657$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $79d7d6ab855f5657$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $79d7d6ab855f5657$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $79d7d6ab855f5657$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $79d7d6ab855f5657$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $79d7d6ab855f5657$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $79d7d6ab855f5657$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $79d7d6ab855f5657$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($79d7d6ab855f5657$var$isKeyEvent(event) || $79d7d6ab855f5657$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($79d7d6ab855f5657$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $79d7d6ab855f5657$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $79d7d6ab855f5657$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $79d7d6ab855f5657$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $79d7d6ab855f5657$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $79d7d6ab855f5657$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $79d7d6ab855f5657$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $79d7d6ab855f5657$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $79d7d6ab855f5657$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $79d7d6ab855f5657$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $79d7d6ab855f5657$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($79d7d6ab855f5657$var$isClickEvent(e.type)) return false;
            if ($79d7d6ab855f5657$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $79d7d6ab855f5657$var$keyToModifiers(key) {
    if (!key) return [];
    key = $79d7d6ab855f5657$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$79d7d6ab855f5657$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $79d7d6ab855f5657$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $79d7d6ab855f5657$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $79d7d6ab855f5657$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $79d7d6ab855f5657$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($79d7d6ab855f5657$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $79d7d6ab855f5657$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($79d7d6ab855f5657$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($79d7d6ab855f5657$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($79d7d6ab855f5657$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($79d7d6ab855f5657$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!el.form._x_pendingModelUpdates) el.form._x_pendingModelUpdates = [];
                el.form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>el.form._x_pendingModelUpdates.splice(el.form._x_pendingModelUpdates.indexOf(syncCallback), 1));
            }
        }
        if (hasEnterModifier) listeners.push($79d7d6ab855f5657$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $79d7d6ab855f5657$var$on(el, event, modifiers, (e)=>{
            setValue($79d7d6ab855f5657$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $79d7d6ab855f5657$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($79d7d6ab855f5657$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $79d7d6ab855f5657$var$on(el.form, "reset", [], (e)=>{
            $79d7d6ab855f5657$var$nextTick(()=>el._x_model && el._x_model.set($79d7d6ab855f5657$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $79d7d6ab855f5657$var$mutateDom(()=>$79d7d6ab855f5657$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $79d7d6ab855f5657$var$getInputValue(el, modifiers, event, currentValue) {
    return $79d7d6ab855f5657$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($79d7d6ab855f5657$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $79d7d6ab855f5657$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $79d7d6ab855f5657$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$79d7d6ab855f5657$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $79d7d6ab855f5657$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $79d7d6ab855f5657$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($79d7d6ab855f5657$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $79d7d6ab855f5657$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $79d7d6ab855f5657$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $79d7d6ab855f5657$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $79d7d6ab855f5657$var$isNumeric2(number) ? number : rawValue;
}
function $79d7d6ab855f5657$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $79d7d6ab855f5657$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $79d7d6ab855f5657$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$79d7d6ab855f5657$var$directive("cloak", (el)=>queueMicrotask(()=>$79d7d6ab855f5657$var$mutateDom(()=>el.removeAttribute($79d7d6ab855f5657$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$79d7d6ab855f5657$var$addInitSelector(()=>`[${$79d7d6ab855f5657$var$prefix("init")}]`);
$79d7d6ab855f5657$var$directive("init", $79d7d6ab855f5657$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$79d7d6ab855f5657$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $79d7d6ab855f5657$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$79d7d6ab855f5657$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $79d7d6ab855f5657$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $79d7d6ab855f5657$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$79d7d6ab855f5657$var$mapAttributes($79d7d6ab855f5657$var$startingWith(":", $79d7d6ab855f5657$var$into($79d7d6ab855f5657$var$prefix("bind:"))));
var $79d7d6ab855f5657$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $79d7d6ab855f5657$var$injectBindingProviders(bindingProviders);
        let getBindings = $79d7d6ab855f5657$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $79d7d6ab855f5657$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $79d7d6ab855f5657$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $79d7d6ab855f5657$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $79d7d6ab855f5657$var$mutateDom(()=>$79d7d6ab855f5657$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$79d7d6ab855f5657$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$79d7d6ab855f5657$var$directive("bind", $79d7d6ab855f5657$var$handler2);
function $79d7d6ab855f5657$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$79d7d6ab855f5657$var$addRootSelector(()=>`[${$79d7d6ab855f5657$var$prefix("data")}]`);
$79d7d6ab855f5657$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($79d7d6ab855f5657$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $79d7d6ab855f5657$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $79d7d6ab855f5657$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $79d7d6ab855f5657$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $79d7d6ab855f5657$var$injectMagics(data2, el);
    let reactiveData = $79d7d6ab855f5657$var$reactive(data2);
    $79d7d6ab855f5657$var$initInterceptors(reactiveData);
    let undo = $79d7d6ab855f5657$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $79d7d6ab855f5657$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $79d7d6ab855f5657$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$79d7d6ab855f5657$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $79d7d6ab855f5657$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$79d7d6ab855f5657$var$isCloning) return false;
    if ($79d7d6ab855f5657$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$79d7d6ab855f5657$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $79d7d6ab855f5657$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $79d7d6ab855f5657$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $79d7d6ab855f5657$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $79d7d6ab855f5657$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$79d7d6ab855f5657$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $79d7d6ab855f5657$var$parseForExpression(expression);
    let evaluateItems = $79d7d6ab855f5657$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $79d7d6ab855f5657$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$79d7d6ab855f5657$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$79d7d6ab855f5657$var$mutateDom(()=>{
                $79d7d6ab855f5657$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $79d7d6ab855f5657$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($79d7d6ab855f5657$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $79d7d6ab855f5657$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $79d7d6ab855f5657$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $79d7d6ab855f5657$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $79d7d6ab855f5657$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $79d7d6ab855f5657$var$mutateDom(()=>{
                $79d7d6ab855f5657$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $79d7d6ab855f5657$var$mutateDom(()=>{
                if (!elForSpot) $79d7d6ab855f5657$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $79d7d6ab855f5657$var$reactive(scope2);
            $79d7d6ab855f5657$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $79d7d6ab855f5657$var$mutateDom(()=>{
                lastEl.after(clone2);
                $79d7d6ab855f5657$var$skipDuringClone(()=>$79d7d6ab855f5657$var$initTree(clone2))();
            });
            if (typeof key === "object") $79d7d6ab855f5657$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $79d7d6ab855f5657$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $79d7d6ab855f5657$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $79d7d6ab855f5657$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $79d7d6ab855f5657$var$handler3() {}
$79d7d6ab855f5657$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $79d7d6ab855f5657$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$79d7d6ab855f5657$var$directive("ref", $79d7d6ab855f5657$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$79d7d6ab855f5657$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $79d7d6ab855f5657$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $79d7d6ab855f5657$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $79d7d6ab855f5657$var$addScopeToNode(clone2, {}, el);
        $79d7d6ab855f5657$var$mutateDom(()=>{
            el.after(clone2);
            $79d7d6ab855f5657$var$skipDuringClone(()=>$79d7d6ab855f5657$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $79d7d6ab855f5657$var$mutateDom(()=>{
                $79d7d6ab855f5657$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$79d7d6ab855f5657$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$79d7d6ab855f5657$var$setIdRoot(el, name));
});
$79d7d6ab855f5657$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$79d7d6ab855f5657$var$mapAttributes($79d7d6ab855f5657$var$startingWith("@", $79d7d6ab855f5657$var$into($79d7d6ab855f5657$var$prefix("on:"))));
$79d7d6ab855f5657$var$directive("on", $79d7d6ab855f5657$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $79d7d6ab855f5657$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $79d7d6ab855f5657$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$79d7d6ab855f5657$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$79d7d6ab855f5657$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$79d7d6ab855f5657$var$warnMissingPluginDirective("Focus", "trap", "focus");
$79d7d6ab855f5657$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $79d7d6ab855f5657$var$warnMissingPluginDirective(name, directiveName, slug) {
    $79d7d6ab855f5657$var$directive(directiveName, (el)=>$79d7d6ab855f5657$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$79d7d6ab855f5657$var$alpine_default.setEvaluator($79d7d6ab855f5657$var$normalEvaluator);
$79d7d6ab855f5657$var$alpine_default.setRawEvaluator($79d7d6ab855f5657$var$normalRawEvaluator);
$79d7d6ab855f5657$var$alpine_default.setReactivityEngine({
    reactive: $79d7d6ab855f5657$var$reactive2,
    effect: $79d7d6ab855f5657$var$effect2,
    release: $79d7d6ab855f5657$var$stop,
    raw: $79d7d6ab855f5657$var$toRaw
});
var $79d7d6ab855f5657$export$b7ee041e4ad2afec = $79d7d6ab855f5657$var$alpine_default;
// packages/alpinejs/builds/module.js
var $79d7d6ab855f5657$export$2e2bcd8739ae039 = $79d7d6ab855f5657$export$b7ee041e4ad2afec;


/**
 * Creates the store for the appearance (light / dark theme).
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $0c531eb0eb863e5f$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("appearance", {
        theme: Alpine.$persist("system").as("theme"),
        init () {
            Alpine.effect(()=>{
                const root = document.documentElement;
                root.setAttribute("data-no-transition", "");
                root.setAttribute("data-theme", this.theme);
                setTimeout(()=>root.removeAttribute("data-no-transition"));
            });
        }
    });
}


const $8d06e390c6380202$var$baseUrl = document.currentScript?.getAttribute("data-base") ?? "/";
const $8d06e390c6380202$var$indexJsonUrl = $8d06e390c6380202$var$baseUrl + "index.json";
function $8d06e390c6380202$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("bookmarks", {
        /**
     * The index of all notes.
     * A key-value map of note URLs to note titles.
     * @type {Record<string, string>}
     */ index: {},
        /**
     * The list of bookmarked notes.
     * @type {string[]}
     */ items: Alpine.$persist([]).as("favorites"),
        async init () {
            this.index = await fetch($8d06e390c6380202$var$indexJsonUrl).then((r)=>r.json()).catch(()=>{
                console.error("Could not fetch notes index");
                return {};
            });
            this.cleanUpBookmarks();
        },
        is (id) {
            return this.items.includes(id);
        },
        /**
     * Toggles the bookmark status of a note.
     * @param {string} id
     */ toggle (id) {
            if (this.items.includes(id)) this.items = this.items.filter((bkm)=>bkm !== id);
            else this.items.push(id);
        },
        cleanUpBookmarks () {
            if (Object.keys(this.index).length === 0) return;
            this.items = this.items.filter((id)=>!!this.index[id]);
        }
    });
}


/**
 * Creates the store for the collapsible sidebar.
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $4bb895f7d67681bf$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("nav", {
        open: false,
        toggle () {
            this.open = !this.open;
        }
    });
}



var $ewJru = parcelRequire("ewJru");
/**
 * Creates the collapsible data for collapsing sections.
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $7b0256c106492184$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("collapsible", (key, defaultExpanded)=>({
            expanded: Alpine.$persist(defaultExpanded).as(`collapsible:${key}`).using(sessionStorage),
            init () {
                if (this.$el.querySelector("[aria-current=page]")) this.expanded = true;
            },
            toggle () {
                this.expanded = !this.expanded;
            }
        }));
}


const $d104974fa1c57088$var$tags = new Set([
    "INPUT",
    "TEXTAREA",
    "SELECT"
]);
function $d104974fa1c57088$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("hotkeys", {
        async register (shortcut, callback) {
            document.addEventListener("keydown", (event)=>{
                if (event.defaultPrevented) return;
                if (event.key !== shortcut || event.metaKey || event.ctrlKey) return;
                if ($d104974fa1c57088$var$tags.has(document.activeElement?.tagName)) return;
                event.preventDefault();
                callback();
            });
        }
    });
}


/**
 * Register the scroll container data object.
 *
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $b8dd5f968bd2f1b6$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("scrollContainer", (identifier)=>({
            key: `scroll-position:${identifier}`,
            init () {
                const value = sessionStorage.getItem(this.key);
                setTimeout(()=>this.$el.scrollTop = parseInt(value, 10));
            },
            container: {
                ["@scroll.debounce"] (event) {
                    sessionStorage.setItem(this.key, event.target.scrollTop);
                }
            }
        }));
}


/**
 * Registers the WindowScroll object for x-bind.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $c2c32f4d15da0450$export$2e2bcd8739ae039(Alpine) {
    Alpine.bind("WindowScroll", ()=>({
            ["@scroll.window"] () {
                this.$el.setAttribute("data-scrolled", window.document.documentElement.scrollTop > 0);
            }
        }));
}


/**
 * Alpine Persist plugin but with error handling.
 * See https://github.com/alpinejs/alpine/blob/main/packages/persist/src/index.js
 *
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $66f82a822e787a89$export$2e2bcd8739ae039(Alpine) {
    let persist = ()=>{
        let alias;
        let storage = localStorage;
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $66f82a822e787a89$var$storageHas(lookup, storage) ? $66f82a822e787a89$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $66f82a822e787a89$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $66f82a822e787a89$var$storageHas(key, storage) ? $66f82a822e787a89$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $66f82a822e787a89$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $66f82a822e787a89$var$storageHas(key, storage) {
    const item = storage.getItem(key);
    const isValid = item !== null && $66f82a822e787a89$var$canParse(item);
    return isValid;
}
function $66f82a822e787a89$var$storageGet(key, storage) {
    return JSON.parse(storage.getItem(key, storage));
}
function $66f82a822e787a89$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
function $66f82a822e787a89$var$canParse(value) {
    try {
        JSON.parse(value);
        return true;
    } catch (e) {
        return false;
    }
}


/**
 * Provides a data object to copy text to the clipboard.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $a7f0716e3e6baee3$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("copyToClipboard", ()=>({
            copied: false,
            copyBtn: {
                ":data-copied" () {
                    return `${this.copied}`;
                },
                async ["@click"] () {
                    const text = this.$el.previousElementSibling.innerText;
                    await navigator.clipboard.writeText(text);
                    this.copied = true;
                    setTimeout(()=>this.copied = false, 1500);
                }
            }
        }));
}


/**
 * Creates the data for the table of contents.
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $73724c2edf7a47bd$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("toc", ()=>({
            activeId: null,
            indicator: {
                start: 0,
                size: 0
            },
            _links: undefined,
            _headings: undefined,
            _nextHash: window.location.hash.slice(1),
            _scrollTimer: 0,
            get indicatorStyles () {
                return {
                    "--toc-indicator-start": `${this.indicator.start}px`,
                    "--toc-indicator-size": `${this.indicator.size}px`
                };
            },
            init () {
                this._links = [
                    ...this.$el.querySelectorAll("a")
                ];
                this._headings = this._links.map((link)=>link.getAttribute("href").slice(1)).map((id)=>document.getElementById(id));
                // Initialize trigger in case the user loads the pagge for the first time
                // without a restored scroll position or hash.
                this.onScroll(false);
            },
            onNavigate (id) {
                // Hash will be used the next time a scroll event is triggered.
                this._nextHash = id;
                // If the hash target is already at the correct position,
                // or scrolling to the target is not possible (e.g. the target is at the bottom of the page
                // and the user is already at the bottom), we trigger the scroll event manually.
                // The timer will be canceled if onScroll() is called by the scroll event.
                this._scrollTimer = window.setTimeout(()=>this.onScroll(true), 50);
            },
            onScroll (throttled = true) {
                window.clearTimeout(this._scrollTimer);
                if (throttled) // We throttle the onScroll event for better performance (via AlpineJS).
                // The last few scroll events will be ignored because of that,
                // resulting in a incorrect position calculation.
                // => Trigger a recalculation with a short delay to fix this.
                this._scrollTimer = window.setTimeout(()=>this.onScroll(false), 60);
                this._calcPosition();
                this._calcIndicator();
            },
            _calcPosition () {
                const topOffset = this._calcTopOffset();
                const headings = this._headings.map((heading)=>{
                    const { top: top, height: height } = heading.getBoundingClientRect();
                    // We activate the heading a bit before it reaches the top.
                    // There is no scientific reason for this value. 🤷‍♂️
                    const allowedArea = topOffset + 2 * height;
                    return {
                        id: heading.id,
                        pos: top,
                        isInFocusAreaOrAbove: top <= allowedArea
                    };
                });
                // If a valid next hash is available, we use it instead of the scroll position
                // because for headings at the bottom of the page, the scroll position is not correct.
                const ids = headings.map((x)=>x.id);
                const idFromNextHash = this._getValidIdFromNextHash(ids);
                if (idFromNextHash) {
                    this.activeId = idFromNextHash;
                    this._nextHash = undefined;
                    // Scrolling to a hash target happens sychronously (we don't use smooth scrolling).
                    // Therefore we don't need to trigger a debounced scroll event,
                    // which would overwrite the position.
                    window.clearTimeout(this._scrollTimer);
                    return;
                }
                // If the user is at the bottom of the page and the page ends
                // with short chapters, the last (few) heading(s) might never be activated.
                // which feels wrong (but many websites have this issue).
                // To fix this, we mark the last heading as active if the user is at the bottom.
                // As a result, the indicator may "jump" a bit when scrolling around
                // which isn't ideal but probably better than the other issue (who knows).
                // We only do this if the page is scrollable, because for short pages
                // that are not scrollable we shouldn't mark the last heading as active.
                const pos = window.scrollY > 0 ? window.innerHeight + window.scrollY : 0;
                const scrollOffset = 10; // Just some random value that feels right.
                const isNearBottom = pos >= document.body.offsetHeight - scrollOffset;
                if (isNearBottom) {
                    this.activeId = headings.at(-1)?.id;
                    return;
                }
                // Now we find the last heading that is not below the focus area
                this.activeId = headings.filter((x)=>x.isInFocusAreaOrAbove).sort((a, b)=>b.pos - a.pos).at(0)?.id ?? null;
            },
            _getValidIdFromNextHash (validIds) {
                const isValid = !!this._nextHash && validIds.includes(this._nextHash) && // Reloading the page with a hash will not focus the heading
                // and restore the scroll position (tested in Brave). In this case,
                // we should not use the hash.
                document.activeElement?.id === this._nextHash;
                return isValid ? this._nextHash : null;
            },
            _calcIndicator () {
                const activeHref = `#${this.activeId}`;
                const activeLink = this.activeId ? this._links.find((x)=>x.getAttribute("href") == activeHref) : undefined;
                if (!activeLink) {
                    this.indicator = {
                        start: 0,
                        size: 0
                    };
                    return;
                }
                const rootElRect = activeLink.closest("ul").getBoundingClientRect();
                const linkRect = activeLink.getBoundingClientRect();
                this.indicator = {
                    start: linkRect.y - rootElRect.y,
                    size: linkRect.height
                };
            },
            _calcTopOffset () {
                // The headings have a scroll margin because of the sticky header.
                // All headings should have the same scroll margin, so it should be fine
                // to use the first heading's scroll margin.
                const style = this._headings.length ? window.getComputedStyle(this._headings[0]) : undefined;
                return style ? parseInt(style.scrollMarginBlockStart, 10) : 0;
            }
        }));
}


(0, $79d7d6ab855f5657$export$2e2bcd8739ae039).plugin((0, $66f82a822e787a89$export$2e2bcd8739ae039));
(0, $0c531eb0eb863e5f$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $8d06e390c6380202$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $4bb895f7d67681bf$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $ewJru.default)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $7b0256c106492184$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $d104974fa1c57088$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $b8dd5f968bd2f1b6$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $c2c32f4d15da0450$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $a7f0716e3e6baee3$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $73724c2edf7a47bd$export$2e2bcd8739ae039)((0, $79d7d6ab855f5657$export$2e2bcd8739ae039));
(0, $79d7d6ab855f5657$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=app.js.map
